import React from 'react';
import { TypedMemo } from '../../../common/types';
import { FirstFileReveal } from './FirstFileReveal';
import { TrialTakeover } from './TrialTakeover';
import { useUpsellAutoModal } from './useUpsellAutoModal';

/**
 * Draws the one automatic upsell modal of the session (`useUpsellAutoModal`): the first-file
 * reveal (design: trial-upsell a1) or the takeover (b3).
 */
const UpsellAutoModalHostComponent: React.FC = () => {
  const { open, close } = useUpsellAutoModal();
  if (open === null) {
    return null;
  }
  if (open === 'firstFile') {
    return <FirstFileReveal onClose={close} />;
  }
  return <TrialTakeover kind={open} onClose={close} />;
};

export const UpsellAutoModalHost = TypedMemo(UpsellAutoModalHostComponent);
